import { TEMPLATE_TYPES } from "utils/constants";
import ACORIS from "../Comparison/Acoris";
import ACORIS_CONSEILLER from "./AcorisConseiller";
import AMELLIS from "./Amellis";
import B2B_RADIANCE_AURA_TER from "./AuraTer";
import B2B_RADIANCE_COSA from "./CosaeTer";
import DEFAULT from "./Default";
import LAFOURGALE from "./Lafourgale";
import LMF from "./Lmf";
import MILTIS from "./Miltis";
import B2B_MUTUAL_MOBILITY from "./MutualMobility";
import B2B_SMART_PHONE from "./SmartPhone";
import SNCA from "./SNCA";
import SOLYON from "./Solyon";
import MCCI from "./MCCI";

const Templates = {
  [TEMPLATE_TYPES.DEFAULT]: DEFAULT,
  [TEMPLATE_TYPES.B2C_ACORIS]: ACORIS,
  [TEMPLATE_TYPES.B2B_ACORIS]: ACORIS_CONSEILLER,
  [TEMPLATE_TYPES.B2B_RADIANCE_COSA]: B2B_RADIANCE_COSA,
  [TEMPLATE_TYPES.B2B_RADIANCE_AURA_TER]: B2B_RADIANCE_AURA_TER,
  [TEMPLATE_TYPES.B2B_SMART_PHONE]: B2B_SMART_PHONE,
  [TEMPLATE_TYPES.B2B_SOLYON]: SOLYON,
  [TEMPLATE_TYPES.B2B_LMF]: LMF,
  [TEMPLATE_TYPES.B2B_MUTUAL_MOBILITY]: B2B_MUTUAL_MOBILITY,
  [TEMPLATE_TYPES.B2B_AMELLIS]: AMELLIS,
  [TEMPLATE_TYPES.B2B_MILTIS]: MILTIS,
  [TEMPLATE_TYPES.B2B_MILTIS_TER]: MILTIS,
  [TEMPLATE_TYPES.B2B_SNCA]: SNCA,
  [TEMPLATE_TYPES.B2B_LAFOURGALE]: LAFOURGALE,
  [TEMPLATE_TYPES.B2B_MCCI]: MCCI,
};
export default Templates;
